<p>
  <strong>Período Previsto</strong>: {{task.dataInicial | date: 'dd/MM'}} até {{task.dataFinal | date: 'dd/MM'}}
</p>
<p ng-if="task.recomendante">
  <strong>Recomendante</strong>: {{task.recomendante}}
</p>
<p ng-if="task.responsavel">
  <strong>Responsável</strong>: {{task.responsavel}}
</p>
<p ng-if="task.cultivar">
  <strong>Cultivar</strong>: {{task.cultivar.descricao}}
</p>
